// iOS 11 modal hack where modal content is not being shown
// NEED TO BE UPDATED if new versions are affected
// https://stackoverflow.com/questions/46339063/ios-11-safari-bootstrap-modal-text-area-outside-of-cursor
var scrollTopPosition;

if (/(iPhone|iPad|iPod).*(OS 11_[0-9]_[0-9])/.test(navigator.userAgent)) {
  function _modalShown() {
    if ($('#whitewrap').css('position') != 'relative') {
        $('#whitewrap').css({
            'position' : 'relative',
            'z-index' : '-1'
        });
    }
  }

  function _modalClosed() {
    if ($('#whitewrap').css('position') != 'static') {
        $('#whitewrap').css({
            'position' : 'static'
        });
    }
  }

  function ios11FBModalHack() {
    if ($('.fancybox-overlay').is(':visible')) {
      _modalShown()
    } else {
      _modalClosed()
    }
  }


  /* b/o: Fancybox ios11 hack */
  setInterval(function() {
    ios11FBModalHack()
  }, 300);
  /* e/o: Fancybox ios11 hack */

  /* b/o: Bootstrap Modal ios11 hack */
  function bsModalIos11() {
    jQuery(document).ready(function($) {
      var iosHackStyle = '<style>.safari-nav-force{height: 100%; overflow-y: scroll; -webkit-overflow-scrolling: touch;}</style>',
          _scrollPosition;

      $('html').append(iosHackStyle);

      function __bsModalShown() {
        _scrollPosition = $(document).scrollTop();
        $('html,body').addClass('safari-nav-force');
      }

      function __bsModalHidden() {
        $('html,body').removeClass('safari-nav-force');
        $(document).scrollTop(_scrollPosition);
      }

      /* b/o: Bootstrap Modal ios11 hack */
      $('.modal[role="dialog"]').on('shown.bs.modal', function() {
        __bsModalShown()
      });

      $('.modal[role="dialog"]').on('hidden.bs.modal', function() {
        __bsModalHidden()
      });
    });
  }

  bsModalIos11();
  /* e/o: Bootstrap Modal ios11 hack */
}

var App = {};

(function ($) {
  // add no translate to datepicker to prevent Google translate from working on it
  jQuery(window).on('di_gravity_forms_loaded', function() {
    if (jQuery('#ui-datepicker-div').length) {
      jQuery('#ui-datepicker-div').addClass('notranslate')
    }
  });

  $.extend(App, {
    DEVICES: {
      MOBILE: 768,
      TABLET_PORTRAIT: 980,
      TABLET_LANDSCAPE: 1200,
      DESKTOP: 1201
    },
    getDevice: function () {
      var w = $(window).width()
      switch (true) {
        case w < 768:
          return this.DEVICES.MOBILE
          break
        case w >= 768 && w < 980:
          return this.DEVICES.TABLET_PORTRAIT
          break
        case w >= 980 && w < 1200:
          return this.DEVICES.TABLET_LANDSCAPE
          break
        default:
          return this.DEVICES.DESKTOP
      }
    },
    getDeviceString: function (val) {
      switch (val) {
        case this.DEVICES.MOBILE: return 'mobile'; break
        case this.DEVICES.TABLET_PORTRAIT: return 'tablet-portrait'; break
        case this.DEVICES.TABLET_LANDSCAPE: return 'tablet-landscape'; break
        default: return 'desktop'; break
      }
    },
    isDevice: function (device) {
      return device == this.getDevice()
    }
  })

  // Gives the ability to unserialize PHP serialized strings, good for retrieving PHP strings that have been serialized

  // Show nav menu items on touch devices
  $('#menu-main-menu ul.sub-menu li.top-level-empty').click(function (e) {
    if (isMobile.any()) {
      window.location.href = $(this).find('a').attr('href')
      return false
    }
  })
  $('#menu-main-menu ul.sub-menu .column').click(function (e) {
    if (isMobile.any() && $(this).children(':first').is('a')) {
      window.location.href = $(this).children(':first').attr('href')
      return false
    }
  })

  // $("#menu-main-menu .top-level-children").click(function(e) {
  //   if(isMobile.any()){
  //     if($(this).children(":first").is('a')){
  //       $("#menu-main-menu .top-level-children").not(this).removeClass('clicked');
  //       if($(this).hasClass('clicked')){
  //         return true;
  //       }else{
  //         $(this).addClass('clicked');
  //       }
  //     }
  //     return false;
  //   }
  //   });
  //
  //
  // $("#menu-main-menu li ul.sub-menu li a").on('touchstart', function(e) {
  //       if(isMobile.any()){
  //         window.location.href = $(this).attr('href');
  //     return false;
  //   }
  //   });

  // Fixes Gravity Forms DatePicker when we have MULTIPLE FORMS WITH A DATEPICKER on the same page
  // There's probably a better solution, but this gets the job done for now!
  // OTHERWISE, PUT THE DATEPICKER CODE IN custom-bonobos.js IF THERE IS ONLY A SINGLE DATEPICKER FIELD

  jQuery(window).ready(function (e) {
    setTimeout(function () {
      
      if (jQuery('.gform_body .datepicker').length > 1) {
        function gotoDate ($j, month, year) {
          $j.each(function (i, el) {
            var inst = $.datepicker._getInst(el)
            inst.drawMonth = inst.selectedMonth = month
            inst.drawYear = inst.selectedYear = year
            $.datepicker._notifyChange(inst)
            $.datepicker._adjustDate(el)
          })
        }

        jQuery('.gform_body .datepicker').datepicker('destroy')
        jQuery('.gform_body .datepicker').each(function () {
          var element = jQuery(this)
          var format = 'mm/dd/yy'

          if (element.hasClass('mdy')) { format = 'mm/dd/yy' } else if (element.hasClass('dmy')) { format = 'dd/mm/yy' } else if (element.hasClass('dmy_dash')) { format = 'dd-mm-yy' } else if (element.hasClass('dmy_dot')) { format = 'dd.mm.yy' } else if (element.hasClass('ymd_slash')) { format = 'yy/mm/dd' } else if (element.hasClass('ymd_dash')) { format = 'yy-mm-dd' } else if (element.hasClass('ymd_dot')) { format = 'yy.mm.dd' }

          var image = ''
          var showOn = 'focus'
          if (element.hasClass('datepicker_with_icon')) {
            showOn = 'both'
            image = jQuery('#gforms_calendar_icon_' + this.id).val()
          }

          element.datepicker({
            yearRange: '-100:+20',
            showOn: showOn,
            buttonImage: image,
            buttonImageOnly: true,
            dateFormat: format,
            changeMonth: true,
            changeYear: true,
            onSelect: function (selected, event) {
              var form_id = jQuery(event.input.context.form).attr('id').replace('gform', 'input')
              var name = jQuery(this).attr('name')
              jQuery("[name='" + name + "'][id^='" + form_id + "']").val(selected)
            }
          }) // eOF: element.datepicker

          // No Sundays on datepicker
          if (jQuery('.gfield.nosundays').length > 0) {
            // destroy default Gravity Form datepicker
            jQuery('.gfield.nosundays .datepicker').datepicker('destroy')
            // create new custom datepicker
            jQuery('.gfield.nosundays .datepicker').datepicker({
              minDate: '+1',
              showOn: 'both',
              buttonImage: '/wp-content/plugins/gravityforms/images/calendar.png',
              buttonImageOnly: true,
              beforeShowDay: function (date) {
                var day = date.getDay()
                return [(day != 0)]
              }
            })
          }

          // No Saturdays on datepicker
          if (jQuery('.gfield.nosaturdays').length > 0) {
            // destroy default Gravity Form datepicker
            jQuery('.gfield.nosaturdays .datepicker').datepicker('destroy')
            // create new custom datepicker
            jQuery('.gfield.nosaturdays .datepicker').datepicker({
              minDate: '+1',
              showOn: 'both',
              buttonImage: '/wp-content/plugins/gravityforms/images/calendar.png',
              buttonImageOnly: true,
              beforeShowDay: function (date) {
                var day = date.getDay()
                return [(day != 6)]
              }
            })
          }

          // No Fridays on datepicker
          if (jQuery('.gfield.nofridayWeekends').length > 0) {
            // destroy default Gravity Form datepicker
            jQuery('.gfield.nofridayWeekends .datepicker').datepicker('destroy')
            // create new custom datepicker
            jQuery('.gfield.nofridayWeekends .datepicker').datepicker({
              minDate: '+1',
              showOn: 'both',
              buttonImage: '/wp-content/plugins/gravityforms/images/calendar.png',
              buttonImageOnly: true,
              beforeShowDay: function(date) {
                var day = date.getDay();
                if( (day == 5) || (day == 6)  || (day == 0) ){
                  return [false, ''];
                }
                else
                  return [true, ''];
              }
            })
          }

          /* WARNING - WARNING -- This code is also located in custom-bonobos.js for multiple Gravity Forms
          * so if you update the code here, you have to replicate it in application.js
          *
          * Set custom minDate options using static classes in the wp-admin > GF > Form editor
          * This will disable the amount of days including todays date
          * YOU MUST ALSO ADD datepicker AS A CLASS FOR THE DATEPICKER FIELD, AS WELL AS THE di_gf_plus_xd
          * So the class input box would look like this: datepicker di_gf_plus_3d
          */

          // enable past dates
          if (jQuery('li.di_past_dates .datepicker').length) {
            jQuery('li.di_past_dates .datepicker').datepicker('option', 'minDate', null);
          }

          // if the datepicker parent has the .di_gf_plus_1d class, then disable todays date
          if (jQuery('li.di_gf_plus_1d .datepicker').length) {
            jQuery('li.di_gf_plus_1d .datepicker').datepicker('option', 'minDate', '+1d')

            if (jQuery('li.di_gf_plus_1d').hasClass('nosundays')) {
              jQuery('li.di_gf_plus_1d .datepicker').datepicker('option', 'beforeShowDay', noSunday)
            }

            if (jQuery('li.di_gf_plus_1d').hasClass('nosaturdays')) {
              jQuery('li.di_gf_plus_1d .datepicker').datepicker('option', 'beforeShowDay', noSaturday)
            }

            if (jQuery('li.di_gf_plus_1d').hasClass('nofridays')) {
              jQuery('li.di_gf_plus_1d .datepicker').datepicker('option', 'beforeShowDay', noFriday)
            }

            if (jQuery('li.di_gf_plus_1d').hasClass('nofridayWeekends')) {
              jQuery('li.di_gf_plus_1d .datepicker').datepicker('option', 'beforeShowDay', noFridayWeekends)
            }

            if (jQuery('li.di_gf_plus_1d').hasClass('noweekends')) {
              jQuery('li.di_gf_plus_1d.noweekends .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
            }

            /* skip weekends on blackout dates - so if the 1st day falls on a Sunday, blackout Monday */
            if (jQuery('li.di_gf_plus_1d').hasClass('blackoutskipweekends')) {
              var oneWorkingDay = new Date()
              var adjustments = [0, 0, 2, 2, 2, 2, 1] // Offsets by day of the week
              oneWorkingDay.setDate(oneWorkingDay.getDate() + 1 + adjustments[oneWorkingDay.getDay()])
              $('li.di_gf_plus_1d .datepicker').datepicker('option', 'minDate', oneWorkingDay)
              $('li.di_gf_plus_1d .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
            }
          }

          // if the datepicker parent has the .di_gf_plus_2d class, then disable today, and next day
          if (jQuery('li.di_gf_plus_2d .datepicker').length) {
            jQuery('li.di_gf_plus_2d .datepicker').datepicker('option', 'minDate', '+2d')

            if (jQuery('li.di_gf_plus_2d').hasClass('nosundays')) {
              jQuery('li.di_gf_plus_2d .datepicker').datepicker('option', 'beforeShowDay', noSunday)
            }

            if (jQuery('li.di_gf_plus_2d').hasClass('nosaturdays')) {
              jQuery('li.di_gf_plus_2d .datepicker').datepicker('option', 'beforeShowDay', noSaturday)
            }

            if (jQuery('li.di_gf_plus_2d').hasClass('nofridays')) {
              jQuery('li.di_gf_plus_2d .datepicker').datepicker('option', 'beforeShowDay', noFriday)
            }

            if (jQuery('li.di_gf_plus_2d').hasClass('nofridayWeekends')) {
              jQuery('li.di_gf_plus_2d .datepicker').datepicker('option', 'beforeShowDay', noFridayWeekend)
            }

            if (jQuery('li.di_gf_plus_2d').hasClass('noweekends')) {
              jQuery('li.di_gf_plus_2d.noweekends .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
            }

            /* skip weekends on blackout dates - so if the 2nd day falls on a Sunday, blackout Monday */
            if (jQuery('li.di_gf_plus_2d').hasClass('blackoutskipweekends')) {
              var twoWorkingDays = new Date()
              var adjustments = [0, 0, 2, 2, 2, 2, 1] // Offsets by day of the week
              twoWorkingDays.setDate(twoWorkingDays.getDate() + 2 + adjustments[twoWorkingDays.getDay()])
              $('li.di_gf_plus_2d .datepicker').datepicker('option', 'minDate', twoWorkingDays)
              $('li.di_gf_plus_2d .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
            }
          }

          // if the datepicker parent has the .di_gf_plus_3d class, then disable today, and the next 2 days
          if (jQuery('li.di_gf_plus_3d .datepicker').length) {
            jQuery('li.di_gf_plus_3d .datepicker').datepicker('option', 'minDate', '+3d')

            if (jQuery('li.di_gf_plus_3d').hasClass('nosundays')) {
              jQuery('li.di_gf_plus_3d .datepicker').datepicker('option', 'beforeShowDay', noSunday)
            }

            if (jQuery('li.di_gf_plus_3d').hasClass('nosaturdays')) {
              jQuery('li.di_gf_plus_3d .datepicker').datepicker('option', 'beforeShowDay', noSaturday)
            }

            if (jQuery('li.di_gf_plus_3d').hasClass('nofridays')) {
              jQuery('li.di_gf_plus_3d .datepicker').datepicker('option', 'beforeShowDay', noFriday)
            }

            if (jQuery('li.di_gf_plus_3d').hasClass('nofridayWeekends')) {
              jQuery('li.di_gf_plus_3d .datepicker').datepicker('option', 'beforeShowDay', noFridayWeekend)
            }

            if (jQuery('li.di_gf_plus_3d').hasClass('noweekends')) {
              jQuery('li.di_gf_plus_3d.noweekends .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
            }

            /* skip weekends on blackout dates - so if the 3rd day falls on a Sunday, blackout Monday */
            if (jQuery('li.di_gf_plus_3d').hasClass('blackoutskipweekends')) {
              var threeWorkingDays = new Date()
              var adjustments = [0, 0, 2, 2, 2, 2, 1] // Offsets by day of the week
              threeWorkingDays.setDate(threeWorkingDays.getDate() + 3 + adjustments[threeWorkingDays.getDay()])
              $('li.di_gf_plus_3d .datepicker').datepicker('option', 'minDate', threeWorkingDays)
              $('li.di_gf_plus_3d .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
            }
          }

          // if the datepicker parent has the .di_gf_plus_4d class, then disable today, and the next 3 days
          if (jQuery('li.di_gf_plus_4d .datepicker').length) {
            jQuery('li.di_gf_plus_4d .datepicker').datepicker('option', 'minDate', '+4d')

            if (jQuery('li.di_gf_plus_4d').hasClass('nosundays')) {
              jQuery('li.di_gf_plus_4d .datepicker').datepicker('option', 'beforeShowDay', noSunday)
            }

            if (jQuery('li.di_gf_plus_4d').hasClass('nosaturdays')) {
              jQuery('li.di_gf_plus_4d .datepicker').datepicker('option', 'beforeShowDay', noSaturday)
            }

            if (jQuery('li.di_gf_plus_4d').hasClass('nofridays')) {
              jQuery('li.di_gf_plus_4d .datepicker').datepicker('option', 'beforeShowDay', noFriday)
            }

            if (jQuery('li.di_gf_plus_4d').hasClass('nofridayWeekends')) {
              jQuery('li.di_gf_plus_4d .datepicker').datepicker('option', 'beforeShowDay', noFridayWeekend)
            }

            if (jQuery('li.di_gf_plus_4d').hasClass('noweekends')) {
              jQuery('li.di_gf_plus_4d.noweekends .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
            }

            /* skip weekends on blackout dates - so if the 4th day falls on a Sunday, blackout Monday */
            if (jQuery('li.di_gf_plus_4d').hasClass('blackoutskipweekends')) {
              var fourWorkingDays = new Date()
              var adjustments = [0, 0, 2, 2, 2, 2, 1] // Offsets by day of the week
              fourWorkingDays.setDate(fourWorkingDays.getDate() + 4 + adjustments[fourWorkingDays.getDay()])
              $('li.di_gf_plus_4d .datepicker').datepicker('option', 'minDate', fourWorkingDays)
              $('li.di_gf_plus_4d .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
            }
          }

          // if the datepicker parent has the .di_gf_plus_5d class, then disable today and the next 4 days
          if (jQuery('li.di_gf_plus_5d .datepicker').length) {
            jQuery('li.di_gf_plus_5d .datepicker').datepicker('option', 'minDate', '+5d')

            if (jQuery('li.di_gf_plus_5d').hasClass('nosundays')) {
              jQuery('li.di_gf_plus_5d .datepicker').datepicker('option', 'beforeShowDay', noSunday)
            }

            if (jQuery('li.di_gf_plus_5d').hasClass('nosaturdays')) {
              jQuery('li.di_gf_plus_5d .datepicker').datepicker('option', 'beforeShowDay', noSaturday)
            }

            if (jQuery('li.di_gf_plus_5d').hasClass('nofridays')) {
              jQuery('li.di_gf_plus_5d .datepicker').datepicker('option', 'beforeShowDay', noFriday)
            }

            if (jQuery('li.di_gf_plus_5d').hasClass('nofridayWeekends')) {
              jQuery('li.di_gf_plus_5d .datepicker').datepicker('option', 'beforeShowDay', noFridayWeekend)
            }

            if (jQuery('li.di_gf_plus_5d').hasClass('noweekends')) {
              jQuery('li.di_gf_plus_5d.noweekends .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
            }

            /* skip weekends on blackout dates - so if the 5th day falls on a Sunday, blackout Monday */
            if (jQuery('li.di_gf_plus_5d').hasClass('blackoutskipweekends')) {
              var fiveWorkingDays = new Date()
              var adjustments = [2, 2, 2, 2, 2, 2, 1] // Offsets by day of the week
              fiveWorkingDays.setDate(fiveWorkingDays.getDate() + 5 + adjustments[fiveWorkingDays.getDay()])
              $('li.di_gf_plus_5d .datepicker').datepicker('option', 'minDate', fiveWorkingDays)
              $('li.di_gf_plus_5d .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
            }
          }

          // if the datepicker parent has the .di_gf_plus_6d class, then disable today and the next 5 days
          if (jQuery('li.di_gf_plus_6d .datepicker').length) {
            jQuery('li.di_gf_plus_6d .datepicker').datepicker('option', 'minDate', '+6d')

            if (jQuery('li.di_gf_plus_6d').hasClass('nosundays')) {
              jQuery('li.di_gf_plus_6d .datepicker').datepicker('option', 'beforeShowDay', noSunday)
            }

            if (jQuery('li.di_gf_plus_6d').hasClass('nosaturdays')) {
              jQuery('li.di_gf_plus_6d .datepicker').datepicker('option', 'beforeShowDay', noSaturday)
            }

            if (jQuery('li.di_gf_plus_6d').hasClass('nofridays')) {
              jQuery('li.di_gf_plus_6d .datepicker').datepicker('option', 'beforeShowDay', noFriday)
            }

            if (jQuery('li.di_gf_plus_6d').hasClass('nofridayWeekends')) {
              jQuery('li.di_gf_plus_6d .datepicker').datepicker('option', 'beforeShowDay', noFridayWeekend)
            }

            if (jQuery('li.di_gf_plus_6d').hasClass('noweekends')) {
              jQuery('li.di_gf_plus_6d.noweekends .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
            }

            /* skip weekends on blackout dates - so if the 6th day falls on a Sunday, blackout Monday */
            if (jQuery('li.di_gf_plus_6d').hasClass('blackoutskipweekends')) {
              var sixWorkingDays = new Date()
              var adjustments = [2, 2, 2, 2, 2, 2, 1] // Offsets by day of the week
              sixWorkingDays.setDate(sixWorkingDays.getDate() + 6 + adjustments[sixWorkingDays.getDay()])
              $('li.di_gf_plus_6d.blackoutskipweekends .datepicker').datepicker('option', 'minDate', sixWorkingDays)
              $('li.di_gf_plus_6d.blackoutskipweekends .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
            }
          }

          // if the datepicker parent has the .di_gf_plus_7d class, then disable today and the next 6 days
          if (jQuery('li.di_gf_plus_7d .datepicker').length) {
            jQuery('li.di_gf_plus_7d .datepicker').datepicker('option', 'minDate', '+7d')

            if (jQuery('li.di_gf_plus_7d').hasClass('nosundays')) {
              jQuery('li.di_gf_plus_7d .datepicker').datepicker('option', 'beforeShowDay', noSunday)
            }

            if (jQuery('li.di_gf_plus_7d').hasClass('nosaturdays')) {
              jQuery('li.di_gf_plus_7d .datepicker').datepicker('option', 'beforeShowDay', noSaturday)
            }

            if (jQuery('li.di_gf_plus_7d').hasClass('nofridays')) {
              jQuery('li.di_gf_plus_7d .datepicker').datepicker('option', 'beforeShowDay', noFriday)
            }

            if (jQuery('li.di_gf_plus_7d').hasClass('nofridayWeekends')) {
              jQuery('li.di_gf_plus_7d .datepicker').datepicker('option', 'beforeShowDay', noFridayWeekend)
            }

            if (jQuery('li.di_gf_plus_7d').hasClass('noweekends')) {
              jQuery('li.di_gf_plus_7d.noweekends .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
            }

            /* skip weekends on blackout dates - so if the 7th day falls on a Sunday, blackout Monday */
            if (jQuery('li.di_gf_plus_7d').hasClass('blackoutskipweekends')) {
              var sevenWorkingDays = new Date()
              var adjustments = [2, 2, 2, 2, 2, 2, 1] // Offsets by day of the week
              sevenWorkingDays.setDate(sevenWorkingDays.getDate() + 7 + adjustments[sevenWorkingDays.getDay()])
              $('li.di_gf_plus_7d .datepicker').datepicker('option', 'minDate', sevenWorkingDays)
              $('li.di_gf_plus_7d .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
            }
          }

           // if the datepicker parent has the .di_gf_plus_14d class, then disable today and the next 6 days
          if (jQuery('li.di_gf_plus_14d .datepicker').length) {
            jQuery('li.di_gf_plus_14d .datepicker').datepicker('option', 'minDate', '+14d')

            if (jQuery('li.di_gf_plus_14d').hasClass('nosundays')) {
              jQuery('li.di_gf_plus_14d .datepicker').datepicker('option', 'beforeShowDay', noSunday)
            }

            if (jQuery('li.di_gf_plus_14d').hasClass('nosaturdays')) {
              jQuery('li.di_gf_plus_14d .datepicker').datepicker('option', 'beforeShowDay', noSaturday)
            }

            if (jQuery('li.di_gf_plus_14d').hasClass('nofridays')) {
              jQuery('li.di_gf_plus_14d .datepicker').datepicker('option', 'beforeShowDay', noFriday)
            }

            if (jQuery('li.di_gf_plus_14d').hasClass('nofridayWeekends')) {
              jQuery('li.di_gf_plus_14d .datepicker').datepicker('option', 'beforeShowDay', noFridayWeekend)
            }

            if (jQuery('li.di_gf_plus_14d').hasClass('noweekends')) {
              jQuery('li.di_gf_plus_14d.noweekends .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
            }

            /* skip weekends on blackout dates - so if the 7th day falls on a Sunday, blackout Monday */
            if (jQuery('li.di_gf_plus_14d').hasClass('blackoutskipweekends')) {
              var sevenWorkingDays = new Date()
              var adjustments = [2, 2, 2, 2, 2, 2, 1] // Offsets by day of the week
              sevenWorkingDays.setDate(sevenWorkingDays.getDate() + 7 + adjustments[sevenWorkingDays.getDay()])
              $('li.di_gf_plus_14d .datepicker').datepicker('option', 'minDate', sevenWorkingDays)
              $('li.di_gf_plus_14d .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
            }
          }

          // disable weekends
          if (jQuery('li.gfield').hasClass('noweekends')) {
            jQuery('li.gfield.noweekends .datepicker').datepicker('option', 'beforeShowDay', $.datepicker.noWeekends)
          }

          function gotoDate ($j, month, year) {
            $j.each(function (i, el) {
              var inst = $.datepicker._getInst(el)
              inst.drawMonth = inst.selectedMonth = month
              inst.drawYear = inst.selectedYear = year
              $.datepicker._notifyChange(inst)
              $.datepicker._adjustDate(el)
            })
          }

          // Define a start date
          if ($('li[class*="sd|"] .datepicker').length) {
            var dateClass = $('li[class*="sd|"] .datepicker').parents('li[class*="sd|"]').attr('class'),
              _date = dateClass.match(/sd\|([^\s]*)/),
              startDate = new Date(_date[1])

            $('li[class*="sd|"] .datepicker').datepicker('option', 'beforeShowDay', function (date) {
              if (date >= startDate) return [true, '']

              return [false, '']
            })

            $('li[class*="sd|"] .datepicker').datepicker('option', 'showOtherMonths', true)

            $('li[class*="sd|"] .datepicker').on('click', function () {
              gotoDate($(this), (startDate.getMonth()), startDate.getFullYear())
            })
          }
          /// /

          // Define an end date
          if ($('li[class*="ed|"] .datepicker').length) {
            var dateClass = $('li[class*="ed|"] .datepicker').parents('li[class*="ed|"]').attr('class'),
              _date = dateClass.match(/ed\|([^\s]*)/),
              endDate = new Date(_date[1])

            $('li[class*="ed|"] .datepicker').datepicker('option', 'beforeShowDay', function (date) {
              if (typeof startDate !== 'undefined' && startDate) {
                if (date >= startDate && date <= endDate) return [true, '']
              } else if (date <= endDate) {
                return [true, '']
              }

              return [false, '']
            })

            $('li[class*="ed|"] .datepicker').datepicker('option', 'showOtherMonths', true)
          }
          /// /

          // disable saturdays along with di_gf_plus_xd
          function noSaturday (date) {
            var day = date.getDay(); return [(day != 6)]
          }

          // disable sundays along with di_gf_plus_xd
          function noSunday (date) {
            var day = date.getDay(); return [(day > 0), '']
          }

          // disable fridays along with di_gf_plus_xd
          function noFriday (date) {
            var day = date.getDay(); return [(day != 5), '']
          }

          // disable fridays & weekends along with di_gf_plus_xd
          function noFridayWeekend (date) {
            var day = date.getDay();
            if( (day == 5) || (day == 6)  || (day == 0) ){
              return [false, ''];
            }
            else
              return [true, ''];
          }

          /*
          * eOF: Static classes for minDate
          */

         /**
          *
          * Add available Times for a testdrive
          * **************
          * If you edit anything in this feature, please make sure to update custom-bonobos.js with the same logic
          * **************
          * * Use the following classes on the form itself (wd = weekday from 8 to 7(19), we = weekend from 8 to 8(20)) use military time for closing time
          *        form_times_available wd|8-19 we|8-20
          * * Add a datepicker field with the following classes:
          *        datepicker available_date_time
          * * Add a dropdown/select field with the following class:
          *        available_time_slots
          */
             /**
              * Increment time by specified increments
              * @param  int start    a whole number from time start (following military time structure)
              * @param  int end      a whole number from time end (following military time structure)
              * @return array       an array
              */
          function getTimeIncrements (start, end, increments) {
            var availableTimes = []
            var open = parseInt(start)
            var close = parseInt(end)
            var timeOfDay = 'AM'
            var currentTime = open
            var inc = increments

            while (open <= close) {
                   // convert military time to regular time
              if (open > 12) {
                currentTime = open - 12
                timeOfDay = 'PM'
              }

                   // stops from selecting the end time (closing time), since they would close before getting a test drive in
              if (open != close) {
                jQuery.each(inc, function (i, val) {
                  availableTimes.push(currentTime + ':' + val + ' ' + timeOfDay)
                       // console.log(currentTime + ":" + val + " " + timeOfDay);
                })
              }

              open++
              currentTime++
            }
            return availableTimes
          }

          jQuery('.available_date_time .datepicker').datepicker('option', 'onSelect', function (dateText, inst) {
            populateAvailableTimes(dateText)
          })

          if (jQuery('form.form_times_available').length) {
            populateAvailableTimes()
          }

          function populateAvailableTimes (dateText) {
            if (jQuery('form.form_times_available').length) {
              var timesFormClass = jQuery('form.form_times_available').attr('class')
              var formClasses = timesFormClass.split(' ')
              jQuery.each(formClasses, function (i, formClass) {
                if (formClass.match(/wd\|/i) != null) {
                  weekdayTimes = formClass.replace(/wd\|/i, '').split('-')
                  weekdayStart = weekdayTimes[0]
                  weekdayEnd = weekdayTimes[1]
                } else if (formClass.match(/we\|/i) != null) {
                  weekendTimes = formClass.replace(/we\|/i, '').split('-')
                  weekendStart = weekendTimes[0]
                  weekendEnd = weekendTimes[1]
                }
              })
            }

            if (typeof dateText === 'undefined') {
              dateText = jQuery('.available_date_time input[type=text]').val()
            }
            var dateSelected = new Date(dateText),
              _day = dateSelected.getDay(),
              dayOfWeek = null,
              timeIncrements = [15, 45]

            var weekdayTimes = {
              open: weekdayStart,
              closed: weekdayEnd
            }

            var weekendTimes = {
              open: weekendStart,
              closed: weekendEnd
            }

            switch (_day) {
              case 0:
                dayOfWeek = {
                  day: 'Sunday',
                  times: getTimeIncrements(weekendTimes.open, weekendTimes.closed, timeIncrements)
                }
                break
              case 1:
                dayOfWeek = {
                  day: 'Monday',
                  times: getTimeIncrements(weekdayTimes.open, weekdayTimes.closed, timeIncrements)
                }
                break
              case 2:
                dayOfWeek = {
                  day: 'Tuesday',
                  times: getTimeIncrements(weekdayTimes.open, weekdayTimes.closed, timeIncrements)
                }
                break
              case 3:
                dayOfWeek = {
                  day: 'Wednesday',
                  times: getTimeIncrements(weekdayTimes.open, weekdayTimes.closed, timeIncrements)
                }
                break
              case 4:
                dayOfWeek = {
                  day: 'Thursday',
                  times: getTimeIncrements(weekdayTimes.open, weekdayTimes.closed, timeIncrements)
                }
                break
              case 5:
                dayOfWeek = {
                  day: 'Friday',
                  times: getTimeIncrements(weekdayTimes.open, weekdayTimes.closed, timeIncrements)
                }
                break
              case 6:
                dayOfWeek = {
                  day: 'Saturday',
                  times: getTimeIncrements(weekendTimes.open, weekendTimes.closed, timeIncrements)
                }
                break
              default :
                dayOfTheWeek = null
            }

            if (jQuery('.available_time_slots select').length) {
              var $available_time_slots = jQuery('.available_time_slots select')
                     // remove blank select values (if any)
              $available_time_slots.find('option:not(.gf_placeholder)').remove()

              if (dayOfWeek && dayOfWeek.times.length) {
                         // remove blank select values (if any)
                $available_time_slots.find('option:not(.gf_placeholder)').remove()
                jQuery.each(dayOfWeek.times, function (i, time) {
                  $available_time_slots.append("<option class='available-time' value='" + time + "'>" + time + '</option>')
                })
              }
            }
          }
               /**
                *
                * e/o: Add available Times for a testdrive
                *
                */
        })
      }

      // Enable today
      if (jQuery('.gfield.di_gf_enable_today').length > 0) {
        var todaysDate = new Date()
        // destroy default Gravity Form datepicker
        $('.gfield.di_gf_enable_today .datepicker').datepicker('option', 'minDate', todaysDate)
      }
      ////


      $(window).trigger('di_gravity_forms_loaded', ['application'])
    }, 500)
  });
})(jQuery)

String.prototype.underscoreToCamelCase = function () {
  return this.replace(/(\_[a-z])/g, function ($1) { return $1.toUpperCase().replace('_', '') })
}

function video_window_resize () {
  if (jQuery(window).width() > 1024) {
    jQuery(document).ready(function ($) {
      $(window).resize(function () {
        var height = $(this).height()
        $('.modfull').height(height)

        // for pagespeed, we hide modfull using bootstrap and show it when modfull kicks in (the height of the videorow is causing false-positive render-blocking style/scripts to show up in PageSpeed)
        if (!$('#videorow.modfull').is(':visible')) {
          $('#videorow.modfull').show()
        }

        // sometimes there's a modfull inside a modfull, this fixes it
        if ($('.modfull').find('#videorow.modfull').length) {
          $('.modfull #videorow.modfull').show()
        }
      })
      $(window).resize() // on page load
    })
  }
}

function video_window_resize_offset (offset) {
  if (jQuery(window).width() > 1024) {
    jQuery(document).ready(function ($) {
      $(window).resize(function () {
        var height = $(this).height()
        $('.modfull').not('#videorow').height(height)
        $('#videorow.modfull, .modfull.variable').height(height - offset)
      })
      $(window).resize() // on page load
    })
  }
}

if (typeof modfullOffset === 'undefined') {
  video_window_resize()
} else {
  video_window_resize_offset(modfullOffset)
}

// b/o: Scroll to VDP Accordion features when clicked on, on tablet and mobile
jQuery(document).ready(function ($) {
  if ($(window).width() <= 1024 && $('body.page-vehicle-display-page #accordionMenu').length) {
    $('body.page-vehicle-display-page #accordionMenu').on('accordionactivate', function (event, ui) {
      if (!$.isEmptyObject(ui.newHeader.offset())) {
        $('html:not(:animated), body:not(:animated)').animate({
          scrollTop: (ui.newHeader.offset().top - 130)
        }, 800)
      }
    })
  }
});
// e/o: Scroll to VDP Accordion features when clicked on, on tablet and mobile

// open fancybox data-mobile-url links in separate window, and cancel the initial fancybox on current window
(function ($) {
  $(document).on('click', '.fancybox', function (event) {
    if (typeof DealerInspireInventory !== 'undefined' && DealerInspireInventory.options.is_inventory_page !== '') { return }

    if (isMobile.any()) {
      var data = $(this).data()
      var url = $(this).attr('href')

      if (data.mobileUrl) { url = data.mobileUrl }

      if (url) {
        // Need to handle Vehicle data if it's available.
        if (!$(this).attr('target') || $(this).attr('target') == '_blank') {
          window.open(data.vehicle ? url + '?' + $.param(data.vehicle) : url)
        } else {
          window.location.href = data.vehicle ? url + '?' + $.param(data.vehicle) : url
        }
        event.stopImmediatePropagation()
        // $.fancybox.cancel();
        // fancybox.close worked better than cancel for some odd reason, so we'll just keep it activated
        $.fancybox.close()
      }

      return false
    }
  })
})(jQuery)

jQuery(document).ready(function ($) {
  /*
  * Modify the breadcrumb link to go back to the previous inventory instance with
  * user selected filters by setting a cookie
  */
  /* bOF: Historic breadcrumbs */
  var $host = window.location.host
  var $path = window.location.pathname

  jQuery(document).on('click', '.vehicle a', function () {
    try {
      if (jQuery(this).attr('href') && jQuery(this).attr('href').search('/inventory/') > -1) {
        var query_string = jQuery.param(DealerInspireInventory.query.to_obj(null, true))
        var host = window.location.host
        DealerInspireCookie.CreateCookie('di_inv_bc_' + host, $path + '#' + query_string, 1)
      }
    } catch (e) {
      if (typeof console != 'undefined') {
        console.log(e);
      }
    }
  })
  if (jQuery('#bc-parent-page').length && DealerInspireCookie.ReadCookie('di_inv_bc_' + $host)) {
    jQuery('#bc-parent-page').attr('href', DealerInspireCookie.ReadCookie('di_inv_bc_' + $host))
  }
  /* eOF: Historic breadcrumbs */

  /* bOF: Already viewed vehicles */
  // Used for "Vehicle Viewed Feature - PHPJS Unserialize to unserialize PHP generated serial strings - No native javascript function to do this
  function unserialize (r) { var e = this, n = function (r) { var e = r.charCodeAt(0); return e < 128 || e >= 160 && e <= 255 || [338, 339, 352, 353, 376, 402, 8211, 8212, 8216, 8217, 8218, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8364, 8482].indexOf(e) != -1 ? 0 : e < 2048 ? 1 : 2 }; return error = function (r, n, a, t) { throw new e.window[r](n, a, t) }, read_until = function (r, e, n) { for (var a = 2, t = [], i = r.slice(e, e + 1); i != n;)a + e > r.length && error('Error', 'Invalid'), t.push(i), i = r.slice(e + (a - 1), e + a), a += 1; return [t.length, t.join('')] }, read_chrs = function (r, e, a) { var t, i, u; for (u = [], t = 0; a > t; t++)i = r.slice(e + (t - 1), e + t), u.push(i), a -= n(i); return [u.length, u.join('')] }, _unserialize = function (r, e) { var n, a, t, i, u, s, o, l, c, d, f, h, _, p, w, b, k, g, v = 0, I = function (r) { return r }; switch (e || (e = 0), n = r.slice(e, e + 1).toLowerCase(), a = e + 2, n) { case 'i':I = function (r) { return parseInt(r, 10) }, c = read_until(r, a, ';'), v = c[0], l = c[1], a += v + 1; break; case 'b':I = function (r) { return parseInt(r, 10) !== 0 }, c = read_until(r, a, ';'), v = c[0], l = c[1], a += v + 1; break; case 'd':I = function (r) { return parseFloat(r) }, c = read_until(r, a, ';'), v = c[0], l = c[1], a += v + 1; break; case 'n':l = null; break; case 's':d = read_until(r, a, ':'), v = d[0], f = d[1], a += v + 2, c = read_chrs(r, a + 1, parseInt(f, 10)), v = c[0], l = c[1], a += v + 2, v != parseInt(f, 10) && v != l.length && error('SyntaxError', 'String length mismatch'); break; case 'a':for (l = {}, t = read_until(r, a, ':'), v = t[0], i = t[1], a += v + 2, s = parseInt(i, 10), u = !0, h = 0; s > h; h++)p = _unserialize(r, a), w = p[1], _ = p[2], a += w, b = _unserialize(r, a), k = b[1], g = b[2], a += k, _ !== h && (u = !1), l[_] = g; if (u) { for (o = new Array(s), h = 0; s > h; h++)o[h] = l[h]; l = o }a += 1; break; default:error('SyntaxError', 'Unknown / Unhandled data type(s): ' + n) } return [n, a - e, I(l)] }, _unserialize(r + '', 0)[2] }

  // if current page is the vehicle results page and the di_vin_history cookie has been found, and has data, then go through each vehicle and add an already viewed class
  if ($('body').hasClass('page-vehicle-results-page')) {
    function applyVisitedClasses () {
      // var vehicle_history = ( typeof DealerInspireCookie.ReadCookie('di_vin_history') !== null ) ? DealerInspireCookie.ReadCookie('di_vin_history') : 0;
      var vehicle_history = (typeof DealerInspireCookie.ReadCookie('di_vehicle_history') !== null) ? DealerInspireCookie.ReadCookie('di_vehicle_history') : 0
      if (vehicle_history) {
        try {
          // Required for Personalizer 1.5.0+
          vehicle_history = JSON.parse(vehicle_history)
        } catch (error) {
          // Legacy (currently '1.4.36.5', '1.4.36.6', '1.4.36.7')
          vehicle_history = unserialize(vehicle_history)
        }
        if (vehicle_history.vins.length) {
          vin_history = vehicle_history.vins
        }
      }

      var avText = (typeof _common_theme !== 'undefined') ? _common_theme.di_application.already_viewed : di_application.already_viewed

      $('.vehicle-overview').each(function (i, el) {
        var current_vin = $(this).attr('id')
        if (typeof vin_history !== 'undefined' && vin_history) {
          if ($.inArray(current_vin, vin_history) > -1) {
            $('#inventory-post-' + current_vin)
            .addClass('vehicle-visited')
            .find('.vehicle-leftcol')
            .append("<span class='visited-title'>" + avText + " <i class='fa fa-check-circle'></i></span>")
          }
        }
      })

      $('.vehicle-wrap').each(function (i, el) {
        var current_vin = $(this).find('div[data-vin]').data('vin')
        if (typeof vin_history !== 'undefined' && vin_history) {
          if ($.inArray(current_vin, vin_history) > -1) {
            $('div[data-vin="' + current_vin + '"]')
            .addClass('vehicle-visited-grid')
            .find('.vehicle-image')
            .append("<span class='visited-title'>" + avText + " <i class='fa fa-check-circle'></i></span>")
          }
        }
      })
    }
    $('body').on('vrp-ready vrp-ajax-complete', function () {
      applyVisitedClasses()
    })
  }
  /* eOF: Already viewed vehicles */

  // bOF: ask a question
  if ($('#ask-a-question-beta').length || $('.headerwrap').length) {
    var i = 10
    // store the ask-a-question bar
    var $ask_question = $('#ask-a-question-beta')
    // get the height from the inventory admin on the Ask a Question tab if it's set. Remove all characters but numbers, will be formatted to pixels later
    var specified_height = (parseInt($ask_question.data('header-height'))) ? $ask_question.data('header-height').replace(/[^0-9.]/g, '') : 0
    // check if the various headers exist
    var $header = ($('#header').length || $('.headerwrap').length) ? $('#header, .headerwrap') : null
    // get the height of the ask a question bar
    var ask_question_height = $ask_question.outerHeight()
    // if #header or .headerwrap exists, then get the height of the #header or .headerwrap, else height is 0
    var header_height = ($header) ? $header.outerHeight(true) : 0
    // hide the ask a question bar and make sure it's position is above the top browser window, and past the header
    var negative_pos = '-' + (ask_question_height + header_height)
    // if the specified height has been entered in admin, then
    var top = (specified_height) || header_height
    // set the initial positioning of the ask a question bar (when the page loads, this line puts the ask a question bar in the high heavens of the browser until it's ready to drop)
    $ask_question.css('top', negative_pos)

    $(window).on('scroll', function (i, el) {
      // check if device is mobile or not
      if ($(window).width() > 1024) {
        var scrollPos = $(window).scrollTop()

        if (scrollPos >= ask_question_height) {
          $ask_question.css({
            'top': top + 'px',
            'opacity': '1'
          })
        } else {
          $ask_question.css({
            'top': negative_pos + 'px',
            'opacity': '0'
          })
        }
      }// e:if
    })
  }
  // eOF: ask a question

  // scroll up automatically on mobile dropdown items clicked to keep them in the viewport
  if ($(document).width() <= 768) {
    $('.dropdown').on('shown.bs.dropdown', function (event) {
      var scroll = $(event.target).offset() // Get the text of the element
      jQuery(this).parents('#sidr').scrollTop(scroll.top)
    })
  }

  // inventory-owl for model feature pages
  if (jQuery('.inventory-owl').length) {
    jQuery('.inventory-owl .grid-view-results-wrapper').owlCarousel({
      center: true,
      autoPlay: false,
      navigation: true,
      items: 4,
      itemsDesktop: [1330, 4],
      itemsDesktopSmall: [979, 3],
      itemsTablet: [768, 2],
      itemsMobile: [479, 1],
      navigationText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
      afterInit: function () {
        $('.inventory-owl').show()
      }
    })

  // b/o Inventory owl for model feature pages that use lightning shortcode [inventory_vehicle_cards]
  setTimeout(function () {
    if(jQuery('.inventory-owl .lvrp-container').length) {
      jQuery('#hits').addClass('swiper-wrapper');
      jQuery('.result-wrap').addClass('swiper-slide');

      var prevBtn = document.createElement('div');
      jQuery(prevBtn).addClass('swiper-btn swiper-button-prev').attr('tabindex', '0').attr('role', 'button').attr('aria-label', 'Previous').html('<');
      jQuery(prevBtn).insertAfter(jQuery('.swiper-wrapper'));

      var nextBtn = document.createElement('div');
      jQuery(nextBtn).addClass('swiper-btn swiper-button-next').attr('tabindex', '0').attr('role', 'button').attr('aria-label', 'Next').html('>');
      jQuery(nextBtn).insertAfter(jQuery('.swiper-button-prev'));


        if ( jQuery('.inventory-owl .lvrp-container #hits > div').length > 0 ) {
          

          var swiper = new Swiper('.inventory-owl .lvrp-container #lvrp-results-wrapper', {
            direction: 'horizontal',
            loop: false,
            autoplay: false,
            freemode: true,
            slidesPerView: 4,
      
            breakpoints: {
                1025: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 1
                }
            },
      
            pagination: {
                el: '.swiper-pagination',
            },
          
            // Navigation arrows
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
          });
        }
      }
  }, 1000);
  // e/o Inventory owl for model feature pages that use lightning shortcode [inventory_vehicle_cards]
  }

  if (jQuery('.inventory-owl-small').length) {
    jQuery('.inventory-owl-small .grid-view-results-wrapper').owlCarousel({
      center: true,
      autoPlay: false,
      navigation: true,
      items: 2,
      itemsDesktop: [1330, 2],
      itemsDesktopSmall: [979, 2],
      itemsTablet: [768, 2],
      itemsMobile: [479, 1],
      navigationText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
      afterInit: function () {
        $('.inventory-owl').show()
      }
    })
  }

  if ($.isFunction($.fn.matchHeight)) {
    $('.staff .staff-item').matchHeight()
    $('.matchable-heights').matchHeight()
  }

  $('.youtube-link').fancybox()

  /*
  * full slide link on flexslider-HG
  * If slide has data attribute data-full-slide-link then make the whole slide clickable (mostly for FJ sites)
  * Aaron Olin
  * */

  if ($('ul.slides li[data-full-slide-link]').length) {
    $('ul.slides li[data-full-slide-link]').on('click', function () {
      // get the URL from the full slide link element
      var url = ($(this).data('full-slide-link').length) ? $(this).data('full-slide-link') : null
      // check if it's target blank or not
      var target_blank = !!((typeof $(this).data('target') !== 'undefined' && $(this).data('target') == 'blank'))
      // if full slide URL is found, then open the link either in the same window or a new tab
      if (url) {
        (target_blank) ? window.open(url, '_blank') : window.location.href = url
      }
      return false
    })
  }

  /*
  * Hide popover when the user taps anywhere on the screen in the details container of the VDP.
  * http://support.dealerinspire.com/helpdesk/tickets/14964
  */
  if ($(window).width() <= 1024) {
    $(document).on('touchstart MSPointerDown', function (e) {
      $('.popover').each(function () {
        // hide any open popovers when the anywhere else in the body is clicked
        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.details-container .popover').has(e.target).length === 0) {
          $(this).popover('hide')
          $('.popover').stop().fadeOut()
        }
      })
    })
  }
})

/*
  The following action resets the iFrame in Gravity Forms after submission.
  This allows users to hit the "back" button in Chrome from the confirmation page.
*/
jQuery(function ($) {
  $(document).on('gform_post_render', function (e, form_id) {
    $('#gform_ajax_frame_' + form_id).attr('src', 'about:blank')
  })
})

DIFancyBoxEventManager = {
  beforeShowCallbacks: [],
  init: function () {
    if (typeof jQuery.fancybox.defaults !== 'undefined') {
      jQuery.fancybox.defaults.beforeShow = DIFancyBoxEventManager._handleBeforeShow
    }
  },
  registerBeforeShow: function (callback, priority) {
    if (!priority) {
      priority = 0
    }

    DIFancyBoxEventManager.beforeShowCallbacks.splice(priority, 0, callback)
  },
  _handleBeforeShow: function () {
    var index = false
    var callback = false
    var self = this

    for (index in DIFancyBoxEventManager.beforeShowCallbacks) {
      callback = DIFancyBoxEventManager.beforeShowCallbacks[index]
      callback.apply(self)
    }
  }
}

jQuery(function () {
  DIFancyBoxEventManager.init()
});

(function ($) {
  if (typeof DIFancyBoxEventManager !== 'undefined') {
    /**
     * Some 3rd parties register their own fancybox that plays off of ours,
     * so we have no way to directly add the disable-iframe-delay class, so we whitelist them
     * @param  object element   the fancybox object
     * @return int              if a domain match was found, then return the count
     */
    function domainWhitelisted(element)
    {
      var matches = 0,
          domains = ['dealerscience'];

      $.each(domains, function(i, domain) {
        var re = new RegExp(domain, 'g');
        if (element.href.match(re)) {
          matches++;
        }
      });

      return matches;
    }

    function iFrameLoadingStatus () {
      var self = this,
          elementClass = $(self.element).attr('class');

      if (self.type == 'iframe' && (! elementClass.match(/disable-iframe-delay/) && ! domainWhitelisted(self))) {

        var loader = $('<div class="fancybox-iframe-loading"><i class="fa fa-spinner fa-spin fa-3x fa-fw margin-bottom"></i></div>')

        $(self.skin).append(loader)

        $(self.skin).find('iframe').on('load', function () {
          $(loader).remove()
        })

        setTimeout(function () {
          $(loader).remove()
        }, 5000)
      }
    }

    DIFancyBoxEventManager.registerBeforeShow(iFrameLoadingStatus, -1)
  }

  // Global var to store DIModal data and selectors for the open/close functionality
  var $DIModal = {
    initd: false,
    isVRP: function () {
      return $('#results-page').length > 0
    },
    content: {
      selector: false,
      parent_el: {
        selector: false,
        index: 0
      },
      hidden: false
    },
    triggerModal: function (location) {
      this.initd = location
      this.openModal()
      this.closeModal()
    },
    openModal: function () {
      var self = this
            // Narrow down the intended content for showing, and setup the modal for display
      $('#DIModal').on('show.bs.modal', function (event) {
        var modal = this
        var source = $(event.relatedTarget)
        var title = source.data('modal-title')
        var content = source.data('modal-content')
        var addClass = source.data('modal-class')
        var footer = source.data('modal-footer')

                // Handle the title
        if (title != null && title != '') { $(modal).find('.modal-header').append('<h4 class="modal-title">' + title + '</h4>') }

                // Handle the content
        if (content != null && content != '') {
                    // Store the original selected element
          self.content.selector = $(content)
          if (self.content.selector.length > 1) {
                        // If more than one element matches the selector, only get the first one
                        // Implies specificity with targeting
            self.content.selector = self.content.selector[0]
          }
          if ($(self.content.selector).css('display') == 'none') {
                        // The content target was hidden, so let's make a note of that
            self.content.hidden = true
          } else {
                        // The content target is already showing, let's make a note
            self.content.hidden = false
          }
                    // Find the immediate parent element, store it
          self.content.parent_el.selector = $(content).parent()
                    // Find the index of the content target in association to its parent so we can re-insert it naturally
          self.content.parent_el.index = $(self.content.parent_el.selector).find('> *').index(self.content.selector)

          if (self.content.hidden) {
                        // Show the content if it is hidden
            $(content).show()
          }
                    //  Append the finally-determined content target to the modal body
          $(modal).find('.modal-body').append(self.content.selector)
        }

                // Handle modal size classes and custom classes
        if (addClass != null && addClass != '') { $(modal).find('.modal-dialog').addClass(addClass) } else { $(modal).find('.modal-dialog').attr('class', 'modal-dialog') }

                // Handle the footer (show/hide)
        if (footer != null && footer != '') {
          if (footer == 'false' || footer == 'hide') {
            $(modal).find('.modal-footer').hide()
          } else {
            var filler = $(footer).length > 0 ? $(footer).clone().show() : footer
            $(modal).find('.modal-footer').show().html(filler)
          }
        } else {
                    // Restore the default view of the footer showing
          $(modal).find('.modal-footer').show()
        }

                // Make damn sure this modal DOM is sitting directly under the <body> at highest tree level
        if ($(modal).parent() != $('body')) { $(modal).detach().appendTo('body') }

                // Debug the saved options object:
                // console.log(self);
      })
    },
    closeModal: function () {
      var self = this
            // Reset the modal and its showcased content on modal close
      $('#DIModal').on('hidden.bs.modal', function (event) {
        var modal = this
        var content = $(modal).find($(self.content.selector))
        if (!self.content.hidden && self.content.parent_el.index < 0) {
          var placement = $(self.content.parent_el.selector).find('> *').eq(self.content.parent_el.index)
        } else {
          var placement = false
        }

        if (placement) {
                    // If placement is specific, let's make sure we get it right
          $(content).insertBefore(placement)
        } else {
                    // The element is hidden, so placement doesn't matter; just append back to parent
          $(content).appendTo($(self.content.parent_el.selector))
        }
        if (self.content.hidden) {
                    // Hide the content again if it was hidden
          $(content).hide()
        }
                // Reset the model title and content (so video embeds stop playing, etc)
        $(modal).find('.modal-body').html(' ')
        $(modal).find('.modal-title').remove()
      })
    },
    init: function () {
      var self = this

      $('body').on('vrp-ready vrp-ajax-complete', function () {
        console.log('vrp-ready')
      });

      // Check if this object has already been initialized
      if (!self.initd) {
        if ($('.di_personalize_loading_message').length > 0 && typeof DI_Personalization_Site !== 'undefined') {
          DI_Personalization_Site.register_hook('content_ready', function () {
            $DIModal.triggerModal('pz')
          })
        } else if ($('#results-page').length > 0) {
            jQuery('body').on('vrp-ready vrp-ajax-complete', function () {
              if (!$DIModal.initd) {
                $DIModal.triggerModal('vrp')
              } else {
                // Because this trigger can fire multiple times on the same page load,
                // we have to remove events on #DIModal and re-set them to avoid duplicate behavior
                $DIModal.destroy()
                $DIModal.triggerModal('vrp')
              }
            })
        } else {
          self.triggerModal('doc')
        }
      }
    },
    destroy: function () {
      var self = this
      $('#DIModal').off()
    }
  }

  $DIModal.init()

}(jQuery))
